import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var NaturalSci = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.801 18.586c.1-1.701-.6-2.402-2.3-2.302-11.203-.9-16.304 5.303-15.103 16.21v.1l-3.401 3.502V23.188c9.102-7.304 9.102-15.509 0-22.813-.5-.5-1.2-.5-1.7 0-9.103 7.204-9.103 15.509-.1 22.813v13.008l-3.601-3.602c1.3-11.707-4.601-17.61-16.104-16.21-.7 0-1.2.5-1.2 1.201-1.3 11.506 4.4 17.41 16.003 16.11l4.901 5.002v4.402c0 .5.4.901.9.901s.9-.4.9-.9v-4.503l4.902-4.903C38.7 34.894 44.7 29.692 43.8 18.586ZM11.994 31.993c-7.801-.4-10.502-5.503-10.102-12.707l12.703 12.707c-.7.1-1.6.1-2.6 0Zm3.901-1.2L3.192 17.985c9.002-.5 13.203 3.902 12.703 12.808Zm5.301-10.006c-6.601-5.903-6.601-12.107 0-18.01v18.01Zm3.601-16.11c5.201 5.704 3.5 11.407-1.9 16.21V2.877c.6.4 1.3 1 1.9 1.8Zm3.3 26.216c-.6-9.006 3.702-13.408 12.704-12.908L28.098 30.893Zm14.004-9.006c-.4 7.705-5.401 10.506-12.603 10.106l12.603-12.707v2.601Z"
  }));
});
NaturalSci.displayName = 'NaturalSci';
NaturalSci.defaultProps = {
  'aria-label': 'NaturalSci'
};
export default NaturalSci;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/NaturalSci.js
// module id = 3046
// module chunks = 11